module.exports = __webpack_public_path__ + "static/media/40-5.ef8be1bd.mp3";